import { writer } from './utils.js';
export function encodeMessage(message, codec) {
    const w = writer();
    codec.encode(message, w, {
        lengthDelimited: false
    });
    return w.finish();
}
